<script>
  import { Router, Route } from './svelte-navigator';
  import { onMount } from 'svelte';
  import { user, debug, readonly } from './stores.js';
  import { Home, History, MacroHistory, Query, Docs, NotFound } from './routes';
  import { UserIcon, LoadingAnimation, Notification } from './components';

  let notification;
  let loading = false;

  onMount(async () => {
    try {
      if ($debug) {
        $user = { userDetails: "roger@clampon.no", userRoles: [ "editor" ] };
      } else {
        $user = await getUserInfo();
        console.log({ user: $user });
      }
      $readonly = !$user.userRoles.includes("editor");
    } catch (error) {
      notification.show("error", "Unable to get user info");
    }
  });
  
  async function getUserInfo() {
    const response = await fetch('/.auth/me');
    const payload = await response.json();
    const { clientPrincipal } = payload;
    return clientPrincipal;
  }

  function onRouteChange(path) {
    if (path === "/") document.title = "Component Monitor";
  }
</script>

<svelte:head>
  <html lang="en" />
</svelte:head>

<main>
  {#if $user}
    <Router primary={false} on:routeChange={(e) => onRouteChange(e.detail.path)}>
      <Route path="/" keepAlive><Home /></Route>
      <Route path="/history/:id" let:params><History id={params.id} /></Route>
      <Route path="/macrohistory"><MacroHistory /></Route>
      <Route path="/query/:id" let:params><Query id={params.id} /></Route>
      <Route path="/docs/:id/:compId" let:params><Docs id={params.id} componentId={params.compId} /></Route>
      <Route><NotFound /></Route>
    </Router>
  {:else}
    <div class="loginContainer">
      <UserIcon size="48" iconSize="2.6x" />
      <a href="/login" class="login">Log in</a>
    </div>
  {/if}
  <div class="loadingBackground" class:visible={loading}><LoadingAnimation bind:visible={loading} /></div>
  <Notification bind:this={notification} />
</main>

<style>
  :global(:root) {
    --label-font-size: 9px;
    --border-radius: 3px;
    --primary-color: #222;
    --error-color: #ff0000;
  }

  :global(body) {
    padding: 0;
  }

  main {
    position: fixed;
    background-color: white;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 5px;
  }

  .loginContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    height: 100%;
  }

  .login {
    text-align: center;
  }

  .loadingBackground {
    position: fixed;
    display: none;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    overflow: auto;
    background-color: transparent;
  }

  .loadingBackground.visible {
    display: flex;
  }
</style>